import React, { useEffect, useMemo, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "flatpickr/dist/themes/material_blue.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { format } from "date-fns";
import InputMask from "react-input-mask";
import Test from "../../components/Common/editPartenaire";
import {
  Col,
  Row,
  Card,
  CardBody,
  CardTitle,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap";
import Select from "react-select";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import IdentificationCard from "components/Common/IdentificationCard";
import SouscriptionsCard from "components/Common/SouscriptionsCard";
import TableComponent from "components/Common/TableComponent";
import { use } from "i18next";
//import { C } from "@fullcalendar/core/internal-common";
import Config from "config";
import useDebounce from "./useDebounce";
function EditCgp() {
  const { id } = useParams();
  const navigate = useNavigate();
  const backUrl = Config.backOffice.url;
  const api = Config.backOffice.apiName;
  const handleTabClick = (tab) => {
    setActiveTab(tab); // Mettre à jour l'état lors du clic sur un onglet
  };

  const tableaustyles = {
    background: "#555B21",
    color: "white",
    paddingTop: "5px",
    paddingBottom: "5px",
  };
  const colStyle = { width: "15em", whiteSpace: "nowrap" };
  const [loading, setLoading] = useState(true);
  const [value, setValue] = useState("");
  const [value1, setValue1] = useState("");
  const handleValueChange = (value) => {
    setValue(value);
  };
  const handleValue1Change = (value) => {
    setValue1(value);
  };
  const token = localStorage.getItem("auth_token_" + api);
  const [cgpData, setCgpData] = useState([]);
  //meta title

  const [activeTab, setActiveTab] = useState("details"); // État pour contrôler l'affichage
  const [IdentificationData, setIdentificationData] = useState([]);
  const [DonneesComplementData, setDonneesComplementData] = useState([]);
  const [DonneesComplementDirectionData, setDonneesComplementDirectionData] =
    useState([]);
  const [DonneesComplementExploitantData, setDonneesComplementExploitantData] =
    useState([]);
  const [hmfData1, setHmfData1] = useState([]);
  const [hmfData2, setHmfData2] = useState([]);
  // QUICK ADD PM
  /*************************   Pays  *******************************/
  const [payData, setPayData] = useState({ data: [] });
  const renderPaysOptions = () => {
    return [
      {
        options: payData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const getPay = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/pays`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pay) => {
          setPayData(pay);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Pays *******************************/
  /*************************   SituationMatrimoniale  *******************************/
  const [situationMatrimonialeData, setSituationMatrimonialeData] = useState({
    data: [],
  });

  const [selectedSituationMatrimoniale, setSelectedSituationMatrimoniale] =
    useState("");

  const renderSituationMatrimonialOptions = () => {
    return [
      {
        options: situationMatrimonialeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const handleSituationMatrimonialeChange = (e) => {
    setSelectedSituationMatrimoniale(e);
  };
  const getSituationMatrimoniale = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/investisseurs/situation_matrimoniales`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((situationMatrimoniale) => {
          setSituationMatrimonialeData(situationMatrimoniale);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   Societe  *******************************/
  const [societeData, setSocieteData] = useState({ data: [] });
  const renderSocieteOptions = () => {
    return [
      {
        options: societeData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const getSociete = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/societes`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((societe) => {
          setSocieteData(societe);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Societe *******************************/
  const [modalOpen, setModalOpen] = useState(false);
  const toggleModal = () => {
    setModalOpen(!modalOpen);
  };
  const [raisonSociale, setRaisonSociale] = useState("");
  const [email, setEmail] = useState("");
  const [telephone, setTelephone] = useState("");
  const [fax, setFax] = useState("");
  const [adresse, setAdresse] = useState("");
  const [codePostal, setCodePostal] = useState("");
  const [ville, setVille] = useState("");
  const [payId, setPayId] = useState(null);
  const [forceRender, setForceRender] = useState(false);
  const [forceRender2, setForceRender2] = useState(false);
  const [forceRender3, setForceRender3] = useState(false);

  const handleSave = () => {
    // Création de l'objet de données à envoyer
    const newData = {
      raison_sociale: raisonSociale,
      email: email,
      telephone: telephone,
      fax: fax,
      adresse: adresse,
      code_postal: codePostal,
      ville: ville,
      pay_id: payId?.value,
    };

    // Configuration de la requête
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newData),
    };

    // Envoi de la requête
    fetch(
      `https://www.fluxod.com/${api}/partenaires_exploitants/create_societe`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          return response.text().then((errorText) => {
            // Convertir le texte de l'erreur en JSON
            const errorMessage = JSON.parse(errorText);
            // Vérifier si "error" est un tableau et afficher tous les messages d'erreur
            if (Array.isArray(errorMessage["error"])) {
              errorMessage["error"].forEach((message) => {
                toast.error(message);
              });
            } else {
              toast.error("Erreur réseau");
            }
            throw new Error(
              errorMessage["error"].join(", ") || "Erreur réseau"
            );
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("Données sauvegardées avec succès:", data);
        setSelectedPm(data);
        setForceRender(!forceRender); // Forcer le re-render du composant
        toast.success("La personne morale a été créée avec succès.");
        setModalOpen(false); // Fermer le modal après avoir sauvegardé
      })
      .catch((error) => {
        console.error("Erreur lors de la sauvegarde des données:", error);
        // Gérer les erreurs, par exemple afficher un message d'erreur à l'utilisateur
      });
  };
  // Quick add PP
  /*************************   Titre  *******************************/
  const [titreData, setTitreData] = useState({ data: [] });
  const [selectedTitre, setSelectedTitre] = useState("");
  const renderTitreOptions = () => {
    return [
      {
        options: titreData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };

  const handleTitreChange = (e) => {
    setSelectedTitre(e);
  };
  const getTitre = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/investisseurs/titres`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((titre) => {
          setTitreData(titre);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*************************   END Titre *******************************/
  const [modalOpen1, setModalOpen1] = useState(false);
  const [titreId, setTitreId] = useState(null);
  const [societeId, setSocieteId] = useState(null);
  const [situationMatrimonial, setSituationMatrimonial] = useState(null);
  const [nom, setNom] = useState("");
  const [prenom, setPrenom] = useState("");
  const [dateDeNaissance, setDateDeNaissance] = useState("");
  const [villeDeNaissance, setVilleDeNaissance] = useState("");
  const [departementOuPays, setDepartementOuPays] = useState("");
  const [profession, setProfession] = useState("");
  const [adresse1, setAdresse1] = useState("");
  const [complement, setComplement] = useState("");
  const [codePostal1, setCodePostal1] = useState("");
  const [ville1, setVille1] = useState("");
  const [payId1, setPayId1] = useState(null);
  const [telFix, setTelFix] = useState("");
  const [telMobil, setTelMobil] = useState("");
  const [emailPro, setEmailPro] = useState("");
  const [emailPerso, setEmailPerso] = useState("");

  const [forceRender1, setForceRender1] = useState(false); // Nouvel état pour forcer le re-render

  const toggleModal1 = () => {
    setModalOpen1(!modalOpen1);
  };
  const handleSocieteChange = (selectedOption) => {
    setSocieteId(selectedOption);
  };
  const handleSituationChange = (selectedOption) => {
    setSituationMatrimonial(selectedOption);
  };
  const handleEmailPersoChange = (e) => {
    setEmailPerso(e.target.value);
  };
  const handleTitreIdChange = (selectedOption) => {
    setTitreId(selectedOption);
  };

  const handlePayIdChange = (selectedOption) => {
    setPayId1(selectedOption);
  };
  const handleSave1 = () => {
    // Création de l'objet de données à envoyer
    const newData = {
      titre_id: titreId,
      nom: nom,
      prenom: prenom,
      date_de_naissance: dateDeNaissance,
      ville_de_naissance: villeDeNaissance,
      departement_ou_pays: departementOuPays,
      profession: profession,
      adresse: adresse1,
      complement: complement,
      code_postal: codePostal1,
      ville: ville1,
      pay_id: payId1,
      tel_fix: telFix,
      tel_mobil: telMobil,
      email_pro: emailPro,
      //
      societe_id: societeId,

      situation_matrimoniale_id: situationMatrimonial,
      email_perso: emailPerso,
    };

    // Configuration de la requête
    const requestOptions = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(newData),
    };

    // Envoi de la requête
    fetch(
      `https://www.fluxod.com/${api}/partenaires_exploitants/create_contact`,
      requestOptions
    )
      .then((response) => {
        if (!response.ok) {
          return response.text().then((errorText) => {
            // Convertir le texte de l'erreur en JSON
            const errorMessage = JSON.parse(errorText);
            // Vérifier si "error" est un tableau et afficher tous les messages d'erreur
            if (Array.isArray(errorMessage["error"])) {
              errorMessage["error"].forEach((message) => {
                toast.error(message);
              });
            } else {
              toast.error("Erreur réseau");
            }
            throw new Error(
              errorMessage["error"].join(", ") || "Erreur réseau"
            );
          });
        }
        return response.json();
      })
      .then((data) => {
        console.log("Données sauvegardées avec succès:", data);
        setSelectedPp(data);
        setForceRender1(!forceRender1); // Forcer le re-render du composant

        toast.success("La personne physique a été créée avec succès.");
        toggleModal1(); // Fermer le modal après avoir sauvegardé
      })
      .catch((error) => {
        console.error("Erreur lors de la sauvegarde des données:", error);
        // Gérer les erreurs, par exemple afficher un message d'erreur à l'utilisateur
      });
  };
  /*************************   Type Partenaire *******************************/
  const [typePartenaireData, setTypePartenaireData] = useState({ data: [] });
  const [selectedType, setSelectedType] = useState("");
  const handleTypeChange = (e) => {
    setSelectedType(e);
  };
  const getType = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/types_partenaires`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((type) => {
          setTypePartenaireData(type);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeOptions = () => {
    return [
      {
        options: typePartenaireData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Personne physique *******************************/
  const [pPData, setPpData] = useState({ data: [] });
  const [selectedPersonnePhysique, setSelectedPp] = useState("");
  const handlePersonneChange = (e) => {
    setSelectedPp(e);
  };
  const getPP = async (key) => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/contacts?key=${key}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pp) => {
          setPpData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPpOptions = () => {
    return [
      {
        options: pPData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Personne Morale *******************************/
  const [pMData, setPmData] = useState({ data: [] });
  const [selectedPm, setSelectedPm] = useState("");
  const handlePmChange = (e) => {
    setSelectedPm(e);
  };
  const getPM = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/societes?key=${value1}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pp) => {
          setPmData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderPmOptions = () => {
    return [
      {
        options: pMData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Type Personne *******************************/
  const [TypePersonneData, setTypePersonneData] = useState({ data: [] });
  const [selectedTypePersonne, setSelectedTypePersonne] = useState("");
  const handleTypePersonneChange = (e) => {
    setSelectedTypePersonne(e);
  };
  const getTypePersonne = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/type_personnes`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((pp) => {
          setTypePersonneData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypePersonneOptions = () => {
    return [
      {
        options: TypePersonneData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Exploitant *******************************/

  const [selectedComptable, setSelectedComptable] = useState("");
  const handleComptableChange = (e) => {
    setSelectedComptable(e);
  };
  const [contactData, setContactData] = useState({ data: [] });

  const getContactData = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/partenaires_exploitants/contacts2`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((pp) => {
          setContactData(pp);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderContactOptions = () => {
    return [
      {
        options: contactData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  const [selectedDataCrea, setSelectedDateCrea] = useState("");
  const handleDataCreaChange = (e) => {
    setSelectedDateCrea(e.target.value);
  };
  const [selectedDateEntree, setSelectedDateEntree] = useState("");
  const handleDateEntreeChange = (e) => {
    setSelectedDateEntree(e.target.value);
  };

  const [selectedImpact, setSelectedImpact] = useState("");
  const handleImpactChange = (e) => {
    setSelectedImpact(e.target.value);
  };

  const [selectedMat, setSelectedMat] = useState("");
  const handleMatChange = (e) => {
    setSelectedMat(e.target.value);
  };

  const [selectedSecteur, setSelectedSecteur] = useState("");
  const handleSecteurChange = (e) => {
    setSelectedSecteur(e.target.value);
  };

  const [selectedSurfaceCons, setSelectedSurfaceCons] = useState("");
  const handleSurfaceConsChange = (e) => {
    setSelectedSurfaceCons(e.target.value);
  };

  const [selectedSurfaceExp, setSelectedSurfaceExp] = useState("");
  const handleSurfaceExpChange = (e) => {
    setSelectedSurfaceExp(e.target.value);
  };

  const [selectedSurfaceTot, setSelectedSurfaceTot] = useState("");
  const handleSurfaceTotChange = (e) => {
    setSelectedSurfaceTot(e.target.value);
  };

  /*************************   Tête de réseau *******************************/
  const [teteReseauData, setTeteReseauData] = useState({ data: [] });
  const [selectedTeteReseau, setSelectedTeteReseau] = useState("");
  const handleTeteReseauChange = (e) => {
    setSelectedTeteReseau(e);
  };
  const getTeteReseau = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/partenaires?id=${id}&types_partenaire_id=${selectedType?.value}`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTeteReseauData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTeteReseauOptions = () => {
    return [
      {
        options: teteReseauData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Taux d'apport  *******************************/
  const [tauxData, setTauxData] = useState({ data: [] });
  const [selectedTaux, setSelectedTaux] = useState("");
  const handleTauxChange = (e) => {
    setSelectedTaux(e);
  };
  const getTaux = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/taux_apports`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTauxData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTauxOptions = () => {
    return [
      {
        options: tauxData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Modèle dossier de souscription & TEPA  *******************************/
  const [modeleData, setModeleData] = useState({ data: [] });
  const [selectedModele, setSelectedModele] = useState("");
  const handleModeleChange = (e) => {
    setSelectedModele(e);
  };
  const [selectedModeleT, setSelectedModeleT] = useState("");
  const handleModeleTChange = (e) => {
    setSelectedModeleT(e);
  };
  const getModele = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/publipostages
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setModeleData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderModeleOptions = () => {
    return [
      {
        options: modeleData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Type de productions  *******************************/
  const [typeProductionData, setTypeProductionData] = useState({ data: [] });
  const [selectedTypeProduction, setSelectedTypeProduction] = useState("");
  const handleTypeProductionChange = (e) => {
    setSelectedTypeProduction(e);
    console.log(selectedTypeProduction);
  };
  const getTypeProduction = async () => {
    try {
      fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/types_de_productions
`,
        {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          setTypeProductionData(data);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderTypeProductionOptions = () => {
    return [
      {
        options: typeProductionData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /*************************   Annee   *******************************/
  const [selectedAnnee, setSelectedAnnee] = useState("");
  const [anneeData, setAnneeData] = useState({ data: [] });
  const handleAnneeChange = (e) => {
    setSelectedAnnee(e);
  };
  const getAnnee = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/partenaires_exploitants/annees`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((annee) => {
          setAnneeData(annee);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderAnneeOptions = () => {
    return [
      <option key="" value=""></option>,
      ...anneeData.data.map((dataItem) => (
        <option key={dataItem.id} value={dataItem.id}>
          {dataItem.label}
        </option>
      )),
    ];
  }; /*************************   Secteur Activite   *******************************/
  const [selectedSecteurActivite, setSelectedSecteurActivite] = useState(null);
  const [secteurData, setSecteurActiviteData] = useState({ data: [] });
  const handleSecteurActiviteChange = (e) => {
    setSelectedSecteurActivite(e);
    getValue(e);
  };
  const getSecteurActivite = async () => {
    try {
      fetch(`https://www.fluxod.com/${api}/partenaires_exploitants/secteurs`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
        .then((response) => response.json())
        .then((annee) => {
          setSecteurActiviteData(annee);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const renderSecteurActiviteOptions = () => {
    return [
      {
        options: secteurData.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /******************************* HMF DonneesFinanciere *******************************************/
  const [formDonneesFinanciere, setFormDonneesFinanciere] = useState({});

  const onAddFormDonneesFinanciere = () => {
    const modifiedDonneesFinanciere = [...formDonneesFinanciere];
    console.log(modifiedDonneesFinanciere);
    modifiedDonneesFinanciere.push({
      index: modifiedDonneesFinanciere.length + 1,
      id: null,
      annee_id: null,
      capitaux_propres: null,
      produits_exploitation: null,
      charges_exploitation: null,
      resultat_exploitation: null,
    });
    console.log(modifiedDonneesFinanciere);
    setFormDonneesFinanciere(modifiedDonneesFinanciere);
  };

  const onDeleteFormDonneesFinanciere = (id) => {
    var modifiedDonneesFinanciere = [...formDonneesFinanciere];
    modifiedDonneesFinanciere = modifiedDonneesFinanciere.filter(
      (x) => x["index"] !== id
    );
    setFormDonneesFinanciere(modifiedDonneesFinanciere);
  };
  const handleInputFinanceChange = (index, field, value) => {
    const modifiedDonneesFinanciere = formDonneesFinanciere.map((donnes) => {
      if (donnes.index === index) {
        return {
          ...donnes,
          [field]: value,
        };
      }
      return donnes;
    });

    setFormDonneesFinanciere(modifiedDonneesFinanciere);
    console.log(modifiedDonneesFinanciere);
  };
  /******************************* END HMF DonneesFinanciere *******************************************/
  /******************************* HMF DonneesInvest *******************************************/
  const [formDonneesInvest, setFormDonneesInvest] = useState({});

  const onAddFormDonneesInvest = () => {
    const modifiedDonneesInvest = [...formDonneesInvest];
    console.log(modifiedDonneesInvest);
    modifiedDonneesInvest.push({
      index: modifiedDonneesInvest.length + 1,
      id: null,
      annee_id: null,
      designation: null,
      base_eligible: null,
      monteur: null,
    });
    console.log(modifiedDonneesInvest);
    setFormDonneesInvest(modifiedDonneesInvest);
  };

  const onDeleteFormDonneesInvest = (id) => {
    var modifiedDonneesInvest = [...formDonneesInvest];
    modifiedDonneesInvest = modifiedDonneesInvest.filter(
      (x) => x["index"] !== id
    );
    setFormDonneesInvest(modifiedDonneesInvest);
  };
  const handleInputInvestChange = (index, field, value) => {
    const modifiedDonneesInvest = formDonneesInvest.map((donnes) => {
      if (donnes.index === index) {
        return {
          ...donnes,
          [field]: value,
        };
      }
      return donnes;
    });

    setFormDonneesInvest(modifiedDonneesInvest);
    console.log(modifiedDonneesInvest);
  };
  /******************************* END HMF DonneesInvest *******************************************/
  /************************************* Select Oui Non  *********************************/
  const OuiNon = {
    data: [
      { id: 1, label: "Oui" },
      { id: 2, label: "Non" },
    ],
  };
  const renderOuiNonOptions = () => {
    return [
      {
        options: OuiNon.data.map((dataItem) => ({
          label: dataItem.label,
          value: dataItem.id,
        })),
      },
    ];
  };
  /************************************* Numero RCS *********************************/
  const [selectedNumero, setSelectedNumero] = useState("");
  const handleNumeroChange = (e) => {
    setSelectedNumero(e.target.value);
  };
  /************************************* Code RCS *********************************/
  const [selectedCode, setSelectedCode] = useState("");
  const handleCodeChange = (e) => {
    setSelectedCode(e.target.value);
  };
  /************************************* Actif *********************************/
  const [selectedActif, setSelectedActif] = useState("");
  const handleActifChange = (e) => {
    setSelectedActif(e);
  };
  /************************************* Défaut *********************************/
  const [selectedDefaut, setSelectedDefaut] = useState("");
  const handleDefautChange = (e) => {
    setSelectedDefaut(e);
  };
  /************************************* Trigramme *********************************/
  const [selectedTrigramme, setSelectedTrigramme] = useState("");
  const handleTrigrammeChange = (e) => {
    setSelectedTrigramme(e.target.value);
  };
  /************************************* Origine *********************************/
  const [selectedOrigine, setSelectedOrigine] = useState("");
  const handleOrigineChange = (e) => {
    setSelectedOrigine(e.target.value);
  };
  /************************************* Compte de créance *********************************/
  const [selectedCompteCreance, setSelectedCompteCreance] = useState("");
  const handleCompteCreanceChange = (e) => {
    setSelectedCompteCreance(e.target.value);
  };
  /************************************* Entrepreteurs *********************************/
  const [selectedEntrepreteur, setSelectedEntrepreteur] = useState("");
  const handleEntrepreteurChange = (e) => {
    setSelectedEntrepreteur(e);
  };

  /******************************* Submit Edit *******************************************/
  const handleNavigate = () => {
    localStorage.setItem("key", true);
    localStorage.setItem("lastId", id);
    navigate(-1);
  };

  const handleSubmitPm = async (event) => {
    event.preventDefault();
    if (selectedPm === null) {
      toast.error("Personne morale ne peut pas être vide");
    } else if (selectedType === null) {
      toast.error("Type ne peut pas être vide");
    } else if (selectedTypePersonne === null) {
      toast.error("Type personne ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/partenaires_exploitants/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              partenaire: {
                id: id,
                type_personne_id: selectedTypePersonne?.value || "",

                societe_id: selectedPm?.value || "",
                defaut: selectedDefaut?.value || "",
                types_partenaire_id: selectedType?.value || "",
                rcs: selectedNumero,
                code_ape: selectedCode,
                actif: selectedActif?.value || "",
                trigramme: selectedTrigramme,
                partenaire_id: selectedTeteReseau?.value || "",
                ///
                // origine: selectedOrigine,
                // taux_apport_id: selectedTaux.map((item) => item.value),
                // publipostage_id: selectedModele?.value,
                // publipostage2_id: selectedModeleT?.value,
                entrepreteurs: selectedEntrepreteur?.value || "",
                ///
                compte_de_creance: selectedCompteCreance,
                ///
                contact2_id: selectedComptable?.value || "",
                impact_sur_lemploi: selectedImpact,
                date_creation_activite: selectedDataCrea,
                surface_totale_detenue: selectedSurfaceTot,
                surface_exploitee: selectedSurfaceExp,
                surface_construite: selectedSurfaceCons,
                materiel_dexploitation: selectedMat,
                secteur_dactivite_de_lexploitant: selectedSecteur,
                secteur_activite_id: selectedSecteurActivite?.value || "",

                date_relation: selectedDateEntree,
                types_de_production_id: selectedTypeProduction.map(
                  (item) => item.value
                ),
              },
              hmf_donnees_exploitants: formDonneesFinanciere.map((obj) => {
                delete obj.index;
                return obj;
              }),
              hmf_donnees_investissements: formDonneesInvest.map((obj) => {
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");

          handleNavigate({ key: true });
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.partenaire_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.partenaire_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite ?");
      }
    }
  };
  const handleSubmitP = async (event) => {
    event.preventDefault();
    if (selectedPm === null) {
      toast.error("Personne morale ne peut pas être vide");
    } else if (selectedType === null) {
      toast.error("Type ne peut pas être vide");
    } else if (selectedTypePersonne === null) {
      toast.error("Type personne ne peut pas être vide");
    } else {
      try {
        const response = await fetch(
          `https://www.fluxod.com/${api}/partenaires_exploitants/update`,
          {
            method: "PATCH",
            headers: {
              Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({
              partenaire: {
                id: id,
                type_personne_id: selectedTypePersonne?.value || "",

                contact_id: selectedPersonnePhysique?.value || "",
                defaut: selectedDefaut?.value || "",
                types_partenaire_id: selectedType?.value || "",
                rcs: selectedNumero,
                code_ape: selectedCode,
                actif: selectedActif?.value || "",
                trigramme: selectedTrigramme,
                partenaire_id: selectedTeteReseau?.value || "",
                date_relation: selectedDateEntree,
                types_de_production_id: selectedTypeProduction.map(
                  (item) => item.value
                ),
                ///
                // origine: selectedOrigine,
                // taux_apport_id: selectedTaux.map((item) => item.value),
                // publipostage_id: selectedModele?.value,
                // publipostage2_id: selectedModeleT?.value,
                entrepreteurs: selectedEntrepreteur?.value || "",
                ///
                compte_de_creance: selectedCompteCreance,
                ///
                contact2_id: selectedComptable?.value || "",
                impact_sur_lemploi: selectedImpact,
                date_creation_activite: selectedDataCrea,
                surface_totale_detenue: selectedSurfaceTot,
                surface_exploitee: selectedSurfaceExp,
                surface_construite: selectedSurfaceCons,
                materiel_dexploitation: selectedMat,
                secteur_dactivite_de_lexploitant: selectedSecteur,
                secteur_activite_id: selectedSecteurActivite?.value || "",
              },
              hmf_donnees_exploitants: formDonneesFinanciere.map((obj) => {
                delete obj.index;
                return obj;
              }),
              hmf_donnees_investissements: formDonneesInvest.map((obj) => {
                delete obj.index;
                return obj;
              }),
            }),
          }
        );

        if (response.ok) {
          console.log("PATCH request successful");

          handleNavigate({ key: true });
        } else {
          console.error("PATCH request failed");
          const responseData = await response.json();
          if (
            (responseData && responseData.societe_validation) ||
            (responseData && responseData.partenaire_validation)
          ) {
            // Si le champ "societe_validation" est présent dans la réponse JSON
            const errors =
              responseData.societe_validation[0] ||
              responseData?.partenaire_validation;

            errors.forEach((error) => {
              toast.error(error);
            });
          } else {
            toast.error("Une erreur s'est produite");
          }
        }
      } catch (error) {
        console.error("An error occurred", error);
        toast.error("Une erreur s'est produite");
      }
    }
  };
  const fetchData = async () => {
    try {
      const response = await fetch(
        `https://www.fluxod.com/${api}/partenaires_exploitants/${id}/edit`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 403) {
        navigate(`${backUrl}/forbidden`);
      }
      if (response.status === 500) {
        navigate(`${backUrl}/error`);
      }
      if (response.status === 203) {
        navigate(`${backUrl}/error404`);
      }
      if (response.status === 401) {
        localStorage.removeItem("auth_token_" + api);
        localStorage.removeItem("authUser_" + api);
        localStorage.removeItem("sideBar_" + api);
        navigate(`${backUrl}/logout`);
        window.location.reload(false);
      }

      const cgpData = await response.json();
      setCgpData(cgpData);
      setIdentificationData(cgpData?.detail_partenaire?.Identification);
      setDonneesComplementDirectionData(
        cgpData?.detail_partenaire?.[
          "Données complémentaires Direction produit"
        ]
      );
      setDonneesComplementData(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]
      );
      setDonneesComplementExploitantData(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]
      );
      setSelectedType(cgpData?.detail_partenaire?.Identification?.Type);
      setSelectedPp(
        cgpData?.detail_partenaire?.Identification?.["Personne Physique"]
      );
      setSelectedPm(
        cgpData?.detail_partenaire?.Identification?.["Personne Morale"]
      );
      setSelectedDateEntree(
        cgpData?.detail_partenaire?.Identification?.["Date entrée en relation"]
      );
      setSelectedNumero(cgpData?.detail_partenaire?.Identification?.["N° RCS"]);
      setSelectedCode(cgpData?.detail_partenaire?.Identification?.["Code APE"]);
      setSelectedActif(cgpData?.detail_partenaire?.Identification?.Actif);
      setSelectedDefaut(cgpData?.detail_partenaire?.Identification?.["Défaut"]);
      setSelectedTrigramme(
        cgpData?.detail_partenaire?.Identification?.Trigramme
      );
      setSelectedCompteCreance(
        cgpData?.detail_partenaire?.[
          "Données complémentaires Direction produit"
        ]?.["Compte de créance"]
      );
      setSelectedTypePersonne(
        cgpData?.detail_partenaire?.Identification?.["Type personne"]
      );
      setSelectedTeteReseau(
        cgpData?.detail_partenaire?.Identification?.["Tête de réseau"]
      );
      setSelectedTaux(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]?.[
          "Taux d'apport (restriction)"
        ]
      );
      setSelectedOrigine(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]?.Origine
      );
      setSelectedModele(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]?.[
          "Modèle dossier de souscription"
        ]
      );
      setSelectedModeleT(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]?.[
          "Modèle dossier de souscription TEPA"
        ]
      );
      setSelectedEntrepreteur(
        cgpData?.detail_partenaire?.["Données complémentaires CGP"]
          ?.Entrepreteurs
      );
      setSelectedCompteCreance(
        cgpData?.detail_partenaire?.[
          "Données complémentaires Direction produit"
        ]?.["Compte de créance"]
      );
      setSelectedComptable(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]
          ?.Comptable
      );
      setSelectedDateCrea(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]?.[
          "Date création activité"
        ]
      );
      setSelectedTypeProduction(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]?.[
          "Types de production"
        ]
      );
      setSelectedImpact(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]?.[
          "Impact sur l'emploi"
        ]
      );
      setSelectedMat(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]?.[
          "Matériel d'exploitation"
        ]
      );
      setSelectedSecteur(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]?.[
          "Secteur d'activité de l'exploitant"
        ]
      );
      setSelectedSecteurActivite(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]?.[
          "Secteur d'activité"
        ]
      );
      setSelectedSurfaceCons(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]?.[
          "Surface construite (m²)"
        ]
      );
      setSelectedSurfaceExp(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]?.[
          "Surface exploitée (ha)"
        ]
      );
      setSelectedSurfaceTot(
        cgpData?.detail_partenaire?.["Données complémentaires exploitant"]?.[
          "Surface totale détenue (ha)"
        ]
      );
      setHmfData1(
        cgpData?.detail_partenaire?.["Données financières exploitant"]?.[
          "Données financières exploitant"
        ]
      );
      setHmfData2(
        cgpData?.detail_partenaire?.["Données autres investissements"]?.[
          "Données autres investissements"
        ]
      );
      setFormDonneesFinanciere(
        cgpData?.detail_partenaire?.["Données financières exploitant"]?.[
          "Données financières exploitant"
        ]?.data
      );
      setFormDonneesInvest(
        cgpData?.detail_partenaire?.["Données autres investissements"]?.[
          "Données autres investissements"
        ]?.data
      );
    } catch (error) {
      console.error(error);
    }
  };
  const CustomNavTabs = () => {
    const navStyle = {
      cursor: "pointer",
      borderRadius: "0px",
      whiteSpace: "nowrap",
    };
    return (
      <Nav pills className="navtab-bg nav-justified custom-nav-tabs">
        <NavItem>
          <NavLink
            style={navStyle}
            className={`nav-link ${activeTab === "details" ? "active" : ""}`}
            to="#details"
            onClick={() => handleTabClick("details")}
          >
            Détails
          </NavLink>
        </NavItem>
      </Nav>
    );
  };
  /************************* Update value *******************************/
  /************************* Update value *******************************/
  const debouncedValueChanged = useDebounce(selectedCode, 2000);
  const [fetchedData, setFetchedData] = useState(null);

  const getValue = async (e) => {
    var url;

    try {
      if (e != null) {
        url = `https://www.fluxod.com/${api}/partenaires_exploitants/update_values?secteur_activite_id=${
          e?.value || ""
        }`;
      } else {
        url = `https://www.fluxod.com/${api}/partenaires_exploitants/update_values?code_ape=${debouncedValueChanged}`;
      }
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      setFetchedData(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (selectedCode != "" && selectedSecteurActivite != null) {
      getValue();
    }
  }, [debouncedValueChanged]);

  useEffect(() => {
    if (fetchedData) {
      setSelectedSecteur(fetchedData?.sil_secteur);

      if (fetchedData?.secteur_activite_id) {
        setSelectedSecteurActivite(fetchedData?.secteur_activite_id);
      }

      setSelectedCode(fetchedData?.code_ape);
    }
    setForceRender2(!forceRender2);
    setForceRender3(!forceRender3);
  }, [fetchedData]);
  const getCodeInvest = () => {};
  return (
    <>
      <React.Fragment>
        <Test
          fetchData={fetchData}
          getType={getType}
          getPP={getPP}
          getTypePersonne={getTypePersonne}
          getPM={getPM}
          getTeteReseau={getTeteReseau}
          getTaux={getTaux}
          getModele={getModele}
          getCodeInvest={getCodeInvest}
          getTypeProduction={getTypeProduction}
          getAnnee={getAnnee}
          getSecteurActivite={getSecteurActivite}
          getContact={getContactData}
          api={"partenaires_exploitants"}
          backUrl={backUrl}
          CustomNavTabs={CustomNavTabs}
          colStyle={colStyle}
          activeTab={activeTab}
          Titre={cgpData.sil}
          TitrePage={"Exploitant agricole"}
          getSociete={getSociete}
          getSituationMatrimonial={getSituationMatrimoniale}
          // Rendu
          renderSituationMatrimonialOptions={renderSituationMatrimonialOptions}
          renderSocieteOptions={renderSocieteOptions}
          renderContactOptions={renderContactOptions}
          renderModeleOptions={renderModeleOptions}
          renderOuiNonOptions={renderOuiNonOptions}
          renderPmOptions={renderPmOptions}
          renderTauxOptions={renderTauxOptions}
          renderTeteReseauOptions={renderTeteReseauOptions}
          renderTypePersonneOptions={renderTypePersonneOptions}
          renderPpOptions={renderPpOptions}
          renderTypeOptions={renderTypeOptions}
          renderTypeProductionOptions={renderTypeProductionOptions}
          renderSecteurActiviteOptions={renderSecteurActiviteOptions}
          // Handlers
          handleCodeChange={handleCodeChange}
          handleActifChange={handleActifChange}
          handleTauxChange={handleTauxChange}
          handleTypeChange={handleTypeChange}
          handleTypePersonneChange={handleTypePersonneChange}
          handleDefautChange={handleDefautChange}
          handleCompteCreanceChange={handleCompteCreanceChange}
          handleTrigrammeChange={handleTrigrammeChange}
          handlePersonneChange={handlePersonneChange}
          handlePmChange={handlePmChange}
          handleNumeroChange={handleNumeroChange}
          handleTeteReseauChange={handleTeteReseauChange}
          handleEntrepreteurChange={handleEntrepreteurChange}
          handleModeleChange={handleModeleChange}
          handleModeleTChange={handleModeleTChange}
          handleOrigineChange={handleOrigineChange}
          handleSubmitP={handleSubmitP}
          handleSubmitPm={handleSubmitPm}
          // Variables
          selectedTaux={selectedTaux}
          selectedActif={selectedActif}
          selectedCode={selectedCode}
          selectedCompteCreance={selectedCompteCreance}
          selectedDefaut={selectedDefaut}
          selectedEntrepreteur={selectedEntrepreteur}
          selectedModele={selectedModele}
          selectedModeleT={selectedModeleT}
          selectedNumero={selectedNumero}
          selectedOrigine={selectedOrigine}
          selectedPersonnePhysique={selectedPersonnePhysique}
          selectedPm={selectedPm}
          selectedTeteReseau={selectedTeteReseau}
          selectedTrigramme={selectedTrigramme}
          selectedType={selectedType}
          selectedTypePersonne={selectedTypePersonne}
          //exploitant
          formDonneesFinanciere={formDonneesFinanciere}
          onAddFormDonneesFinanciere={onAddFormDonneesFinanciere}
          onDeleteFormDonneesFinanciere={onDeleteFormDonneesFinanciere}
          selectedTypeProduction={selectedTypeProduction}
          selectedComptable={selectedComptable}
          selectedDataCrea={selectedDataCrea}
          selectedDateEntree={selectedDateEntree}
          selectedImpact={selectedImpact}
          selectedMat={selectedMat}
          selectedSecteur={selectedSecteur}
          selectedSecteurActivite={selectedSecteurActivite}
          selectedSurfaceCons={selectedSurfaceCons}
          selectedSurfaceExp={selectedSurfaceExp}
          selectedSurfaceTot={selectedSurfaceTot}
          handleComptableChange={handleComptableChange}
          handleDataCreaChange={handleDataCreaChange}
          handleDateEntreeChange={handleDateEntreeChange}
          handleImpactChange={handleImpactChange}
          handleMatChange={handleMatChange}
          handleSecteurChange={handleSecteurChange}
          handleSecteurActiviteChange={handleSecteurActiviteChange}
          handleSurfaceConsChange={handleSurfaceConsChange}
          handleSurfaceExpChange={handleSurfaceExpChange}
          handleSurfaceTotChange={handleSurfaceTotChange}
          handleTypeProductionChange={handleTypeProductionChange}
          renderAnneeOptions={renderAnneeOptions}
          handleInputFinanceChange={handleInputFinanceChange}
          formDonneesInvest={formDonneesInvest}
          onAddFormDonneesInvest={onAddFormDonneesInvest}
          onDeleteFormDonneesInvest={onDeleteFormDonneesInvest}
          handleInputInvestChange={handleInputInvestChange}
          value={value}
          setValue={handleValueChange}
          value1={value1}
          setValue1={handleValue1Change}
          // Données variables
          IdentificationData={IdentificationData}
          DonneesComplementData={DonneesComplementData}
          DonneesComplementDirectionData={DonneesComplementDirectionData}
          DonneesComplementExploitantData={DonneesComplementExploitantData}
          hmfData1={hmfData1}
          hmfData2={hmfData2}
          // quick add
          getTitre={getTitre}
          getPay={getPay}
          handleSave={handleSave}
          handleSave1={handleSave1}
          setPayId={setPayId}
          handlePayIdChange={handlePayIdChange}
          renderPaysOptions={renderPaysOptions}
          renderTitreOptions={renderTitreOptions}
          handleSituationMatrimonialChange={handleSituationChange}
          handleSocieteChange={handleSocieteChange}
          setEmailPerso={setEmailPerso}
          modalOpen={modalOpen}
          modalOpen1={modalOpen1}
          toggleModal={toggleModal}
          toggleModal1={toggleModal1}
          handleTitreIdChange={handleTitreIdChange}
          setRaisonSociale={setRaisonSociale}
          setEmail={setEmail}
          setTelephone={setTelephone}
          setEmailPro={setEmailPro}
          emailPerso={emailPerso}
          setFax={setFax}
          setAdresse={setAdresse}
          setAdresse1={setAdresse1}
          setCodePostal={setCodePostal}
          setCodePostal1={setCodePostal1}
          setVille={setVille}
          setNom={setNom}
          setPrenom={setPrenom}
          setDateDeNaissance={setDateDeNaissance}
          setVilleDeNaissance={setVilleDeNaissance}
          setDepartementOuPays={setDepartementOuPays}
          setProfession={setProfession}
          setComplement={setComplement}
          setVille1={setVille1}
          setTelFix={setTelFix}
          setTelMobil={setTelMobil}
          forceRender={forceRender}
          forceRender1={forceRender1}
          forceRender2={forceRender2}
          forceRender3={forceRender3}
          telMobil={telMobil}
        />

        <ToastContainer />
      </React.Fragment>
    </>
  );
}

export default EditCgp;
